import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'convertString'
})
export class ConvertStringPipe implements PipeTransform {

  transform(value: any) {
    if (value) {
      return parseInt(value);
    }
    return null;
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/pipes/convert-string.pipe.ts